import React, { FC, ReactElement, ReactNode } from 'react'
import { LanguageContextProvider, MessageContextProvider, PromptContextProvider } from './Contexts'

type Props = {
    isRouterMode?: boolean
    children: ReactNode
}

export const BaseContexts: FC<Props> = ({ isRouterMode, children }: Props): ReactElement => (
    <LanguageContextProvider>
        <PromptContextProvider isRouterMode={isRouterMode}>
            <MessageContextProvider>{children}</MessageContextProvider>
        </PromptContextProvider>
    </LanguageContextProvider>
)
